import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CultureFacade } from '../../cultures/facade/cultures.facade';
import {
  setActiveCategoryAction,
  setActiveCategoryListingPageAction,
} from '../actions/categories.action';
import {
  selectActiveCategory,
  selectActiveCategoryListingPage,
} from '../selectors/categories.selector';
import { CategoriesState } from '../reducers/categories.reducer';

@Injectable({
  providedIn: 'root',
})
export class CategoriesFacade {
  protected store = inject<Store<CategoriesState>>(Store);
  protected cultureFacade = inject(CultureFacade);

  setActiveCategory(categoryId: string): void {
    this.store.dispatch(setActiveCategoryAction({ categoryId }));
  }

  setActiveCategoryListingPage(categoryId: {
    itemCategory: string;
    itemCategory2: string;
  }): void {
    this.store.dispatch(setActiveCategoryListingPageAction(categoryId));
  }

  getActiveCategory(): Observable<string | undefined> {
    return this.store.pipe(select(selectActiveCategory));
  }

  getActiveCategoryListingPage(): Observable<
    | { itemCategory: string; itemCategory2: string }
    | undefined
    | Record<string, never>
  > {
    return this.store.pipe(select(selectActiveCategoryListingPage));
  }

  clearActiveCategory(): void {
    this.store.dispatch(setActiveCategoryAction({}));
  }

  clearActiveCategoryListingPage(): void {
    this.store.dispatch(setActiveCategoryListingPageAction({}));
  }
}
